export default [
  [
    'How do I see a person’s transaction history?',
    'The Person Search is best utilized if you have a specific target in mind as you can search by First and Last Name at a minimum; it’s also great to search an address to determine who is buying PSE.',
  ],
  [
    'How do I determine a group of individuals buying together?',
    'It is recommended to click Proximity Search, from the Person Summary Page, to see if the target is buying with other individuals.  Proximity Search groups individuals together if they have NPLEx activity on 4 or more occasions, at the same store or a store within a 2-mile radius, within an hour of each other.',
  ],
  [
    'How do I view transactions for a specific pharmacy?',
    'The Store Activity report displays all PSE transactions from a specific pharmacy including purchases and blocks for up to 90 days.',
  ],
  [
    'How do I identify people who were blocked in my county or city? Or people who have bought a certain number of boxes or grams?',
    'The Geo Activity report allows you to run a proactive search in NPLEx to view the activity going on in your area.  For example, determine individuals who have been blocked in your county or city or who have purchased 2 or more boxes or 4.8 grams or more in the past 2 weeks.',
  ],
  [
    'How do I see what pharmacy is selling the most PSE in my state/county?',
    'The Transaction Summary report provides stats on participating pharmacies, boxes sold/blocked, and grams sold/blocked for the date range and location selected (state or county).  It also highlights who the hot pharmacies are in the area.',
  ],
  [
    'How can I find who purchased from a receipt found in a dumpsite or trash pull?',
    'Perform a Transaction ID Lookup to enter the transaction ID number found on a receipt to identify who purchased the PSE item. If the transaction ID # is not working, you can run a Store Activity Report for that pharmacy, date, and time of the transaction to identify the person.',
  ],
  [
    'How do I view multiple individual’s transactions at once?',
    'Run a Multiple ID Search to view their PSE buying activity in one report.',
  ],
  [
    'Can I view multiple pharmacies transactions in real-time?',
    'Yes! You can do the Store Feed and specify up to 10 pharmacies from 5 different zip codes to receive real-time activity as the transactions are submitted to the NPLEx system.',
  ],
  [
    'Can I receive real-time notifications on specific target’s PSE activity?',
    'Yes! You can put a “Watch” on a target to receive an email notification in real-time if that person purchases or is blocked from purchasing PSE.  You can add a Watch from the Person Summary Page, or manually under the Watch Tab.',
  ],
]
